/* nav-produit.js : haut de fiche Navumia (lot HAUT DE FICHE 2026-10-23). Sans dependance.
   Galerie (glisser, vignettes + fleches, zoom), pastilles de couleur (id cache, ?variant=, image de la couleur),
   ajout au panier : fetch /cart/add (Moon Bundle l'intercepte et ajoute l'offre cochee), puis tiroir panier natif d'Horizon
   (CartLinesUpdateEvent de @shopify/events -> le tiroir se met a jour, puis theme-drawer#cart-drawer.open()) ; repli : page panier.
   Estimation de livraison : aujourd'hui + 6 et + 10 jours ouvres (samedi et dimanche sautes). */
(function () {
  'use strict';
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function beh() { return reduce ? 'auto' : 'smooth'; }

  /* ---------- galerie ---------- */
  function initGallery(root) {
    var gal = $('[data-nav-gal]', root); if (!gal) return;
    var track = $('[data-nav-track]', gal), slides = $$('[data-nav-slide]', track);
    var thumbs = $$('[data-nav-thumb]', gal), tl = $('[data-nav-th-list]', gal);
    var prev = $('[data-nav-th-prev]', gal), next = $('[data-nav-th-next]', gal);
    var idx = -1;
    function left(i) { return slides[i] ? slides[i].offsetLeft - slides[0].offsetLeft : 0; }
    function arrows() {
      if (!tl) return;
      if (prev) prev.disabled = tl.scrollLeft <= 2;
      if (next) next.disabled = tl.scrollLeft + tl.clientWidth >= tl.scrollWidth - 2;
    }
    function showThumb(i, b) {
      var t = thumbs[i]; if (!t || !tl) return;
      var li = t.parentNode, x = li.offsetLeft - tl.firstElementChild.offsetLeft;
      if (x < tl.scrollLeft || x + li.offsetWidth > tl.scrollLeft + tl.clientWidth) tl.scrollTo({ left: Math.max(0, x - (tl.clientWidth - li.offsetWidth) / 2), behavior: b || beh() });
    }
    function mark(i, b) {
      if (i === idx) return; idx = i;
      thumbs.forEach(function (t, k) { if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      showThumb(i, b);
    }
    function go(i, b) {
      if (!slides.length) return;
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: left(i), behavior: b || beh() });
      mark(i, b);
    }
    var raf = 0;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0; var x = track.scrollLeft, best = 0, bd = Infinity;
        for (var k = 0; k < slides.length; k++) { var d = Math.abs(left(k) - x); if (d < bd) { bd = d; best = k; } }
        mark(best);
      });
    }, { passive: true });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    function stepTh(dir) {
      if (!tl) return;
      var li = tl.firstElementChild, st = li ? li.offsetWidth + 10 : 100;
      tl.scrollBy({ left: dir * st * 3, behavior: beh() });
    }
    if (prev) prev.addEventListener('click', function () { stepTh(-1); });
    if (next) next.addEventListener('click', function () { stepTh(1); });
    if (tl) { tl.addEventListener('scroll', arrows, { passive: true }); window.addEventListener('resize', arrows); }
    var start = +gal.getAttribute('data-start') || 0;
    idx = -1;
    if (start > 0) { requestAnimationFrame(function () { go(start, 'auto'); arrows(); }); } else { mark(0, 'auto'); }
    arrows();
    root.__navGo = go; root.__navIdx = function () { return idx < 0 ? 0 : idx; };
  }

  /* ---------- visionneuse (zoom) ---------- */
  function initLightbox(root) {
    var lb = $('[data-nav-lb]', root); if (!lb || typeof lb.showModal !== 'function') return;
    var tr = $('[data-nav-lb-track]', lb), n = $$('.nav-lb__slide', lb).length; if (!n) return;
    if (lb.parentNode !== document.body) document.body.appendChild(lb);
    function cur() { return Math.round(tr.scrollLeft / (tr.clientWidth || 1)); }
    function to(k) { k = Math.max(0, Math.min(n - 1, k)); tr.scrollTo({ left: k * tr.clientWidth, behavior: beh() }); }
    function open(i) {
      $$('img', lb).forEach(function (im) { im.loading = 'eager'; });
      lb.showModal(); document.documentElement.classList.add('nav-lb-open');
      tr.scrollTo({ left: (i || 0) * tr.clientWidth, behavior: 'auto' });
    }
    $$('[data-nav-zoom]', root).forEach(function (b) { b.addEventListener('click', function () { open(+b.getAttribute('data-nav-zoom')); }); });
    $('[data-nav-lb-close]', lb).addEventListener('click', function () { lb.close(); });
    $('[data-nav-lb-prev]', lb).addEventListener('click', function () { to(cur() - 1); });
    $('[data-nav-lb-next]', lb).addEventListener('click', function () { to(cur() + 1); });
    lb.addEventListener('close', function () { document.documentElement.classList.remove('nav-lb-open'); });
    lb.addEventListener('click', function (e) { if (e.target === lb || e.target.classList.contains('nav-lb__slide')) lb.close(); });
    lb.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') to(cur() - 1); if (e.key === 'ArrowRight') to(cur() + 1); });
  }

  /* ---------- donnees produit ---------- */
  function data(root) {
    var j = $('[data-nav-data]', root), d = null;
    try { d = JSON.parse(j.textContent); } catch (e) {}
    return d || { v: [], txt: {} };
  }

  /* ---------- pastilles de couleur ---------- */
  function initOptions(root, d) {
    var ins = $$('.nav-sw__in', root); if (!ins.length) return;
    var idIn = $('[data-nav-id]', root), add = $('[data-nav-add]', root), lbl = $('[data-nav-add-txt]', root);
    function pick() {
      var sel = [];
      $$('[data-nav-opt]', root).forEach(function (fs) {
        var c = $('.nav-sw__in:checked', fs); sel[+fs.getAttribute('data-nav-opt')] = c ? c.value : null;
      });
      for (var i = 0; i < d.v.length; i++) {
        var v = d.v[i], ok = true;
        for (var k = 0; k < sel.length; k++) { if (sel[k] != null && v.o[k] !== sel[k]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function apply() {
      var v = pick();
      if (!v) { if (add) { add.disabled = true; } return; }
      if (idIn && String(idIn.value) !== String(v.id)) {
        idIn.value = v.id;
        idIn.dispatchEvent(new Event('input', { bubbles: true }));
        idIn.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (add) { add.disabled = !v.a; if (lbl) lbl.textContent = v.a ? (d.txt.add || lbl.textContent) : (d.txt.out || lbl.textContent); }
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.toString()); } catch (e) {}
      if (v.m >= 0 && root.__navGo) root.__navGo(v.m);
    }
    ins.forEach(function (i) { i.addEventListener('change', apply); });
  }

  /* ---------- tiroir panier natif Horizon ---------- */
  /* 26/10 : Shopify minifie ce fichier et transforme les imports dynamiques en require (inexistant dans le navigateur) :
     le tiroir ne se redessinait jamais (« Votre panier est vide »). On importe via un petit script module, que le minifieur ne touche pas. */
  var navImp = null;
  function navImport(m) {
    if (!navImp) navImp = new Promise(function (res, rej) {
      if (window.__navImport) return res(window.__navImport);
      window.addEventListener('nav:import-pret', function () { res(window.__navImport); }, { once: true });
      var s = document.createElement('script'); s.type = 'module';
      s.textContent = 'window.__navImport=function(m){return import(m)};window.dispatchEvent(new Event("nav:import-pret"))';
      document.head.appendChild(s);
      setTimeout(function () { if (!window.__navImport) rej(new Error('import indisponible')); }, 4000);
    });
    return navImp.then(function (f) { return f(m); });
  }
  function openDrawer(form, varId) {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer || typeof drawer.open !== 'function') return Promise.reject(new Error('pas de tiroir'));
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var su = new URL(location.href); su.searchParams.delete('variant'); su.searchParams.set('sections', 'cart-drawer-section');
    var pCart = fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); });
    var pSec = fetch(su.toString(), { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    var pEv = navImport('@shopify/events').catch(function () { return null; });
    return Promise.all([pCart, pSec, pEv]).then(function (r) {
      var cart = r[0], secs = r[1], ev = r[2];
      if (!cart || typeof cart.item_count !== 'number' || cart.item_count < 1) throw new Error('panier vide');
      if (ev && ev.CartLinesUpdateEvent) {
        var dp = ev.CartLinesUpdateEvent.createPromise();
        form.dispatchEvent(new ev.CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: String(varId), quantity: 1 }], promise: dp.promise }));
        dp.resolve({ cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'nav-produit', sourceId: form.id, itemCount: 1, sections: secs || undefined, didError: false } });
      }
      /* 26/10 : l'evenement seul ne redessine pas le tiroir (il restait « Votre panier est vide ») -> on le redessine toujours. */
      if (secs && secs['cart-drawer-section']) {
        return navImport('@theme/section-renderer').then(function (m) { if (m && m.morphSection) return m.morphSection('cart-drawer-section', secs['cart-drawer-section'], { mode: 'hydration' }); });
      }
      throw new Error('tiroir sans contenu');
    }).then(function () {
      return new Promise(function (res) {
        requestAnimationFrame(function () { try { var d = document.getElementById('cart-drawer') || drawer; if (!d.isOpen) d.open(); } catch (e) {} res(); });
      });
    }).then(function () {
      var d = document.getElementById('cart-drawer') || drawer;
      if (!d.hasAttribute('open')) throw new Error('tiroir ferme');
      if (d.querySelector('.cart-drawer--empty')) throw new Error('tiroir vide');
    });
  }

  /* ---------- formulaire ---------- */
  function initForm(root, d) {
    var form = $('[data-nav-form]', root); if (!form) return;
    var add = $('[data-nav-add]', form), err = $('[data-nav-err]', form), idIn = $('[data-nav-id]', form);
    var cartUrl = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart';
    function fail(msg) { err.textContent = msg || d.txt.err || ''; err.hidden = false; }
    form.addEventListener('submit', function (e) {
      if (e.defaultPrevented) return;
      e.preventDefault();
      if (add.disabled || add.classList.contains('is-busy')) return;
      add.classList.add('is-busy'); add.setAttribute('aria-busy', 'true'); err.hidden = true;
      var varId = idIn ? idIn.value : '';
      window.fetch(form.getAttribute('action') || '/cart/add', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok || (res.j && res.j.status)) { fail(res.j && (res.j.description || res.j.message)); return; }
          return new Promise(function (ok) { setTimeout(ok, 450); })
            .then(function () { return openDrawer(form, varId); })
            .catch(function () { location.href = cartUrl; });
        })
        .catch(function () { fail(); })
        .then(function () { add.classList.remove('is-busy'); add.removeAttribute('aria-busy'); });
    });
  }

  /* ---------- estimation de livraison ---------- */
  function initDelivery(root) {
    var a = $('[data-nav-dmin]', root), b = $('[data-nav-dmax]', root); if (!a || !b) return;
    function plus(n) { var d = new Date(); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; }
    function fmt(d) { try { return d.toLocaleDateString('fr-BE', { weekday: 'long', day: 'numeric', month: 'long' }); } catch (e) { return ''; } }
    var x = fmt(plus(6)), y = fmt(plus(10));
    if (x) a.textContent = x; if (y) b.textContent = y;
  }

  /* ---------- colonne collante sous un en-tete fixe ---------- */
  function initStick(root) {
    var h = document.querySelector('#header-component');
    function upd() {
      var off = 0;
      if (h && h.getAttribute('sticky') === 'always') off = Math.round(h.getBoundingClientRect().height);
      root.style.setProperty('--nav-stick', off + 'px');
    }
    upd(); window.addEventListener('resize', upd);
  }

  function init() {
    $$('[data-nav-prod]').forEach(function (root) {
      if (root.__nav) return; root.__nav = 1;
      var d = data(root);
      initGallery(root); initLightbox(root); initOptions(root, d); initForm(root, d); initDelivery(root); initStick(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
